import React from 'react'

interface JCBIconProps {
  width?: number
  height?: number
  className?: string
}

const JCBIcon: React.FC<JCBIconProps> = ({
  width = 35,
  height = 24,
  className = ''
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="0.5"
        width="34"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D9D9D9"
      />
      <g transform="translate(8, 5)">
        <path
          d="M14.3181 8.28733C14.8318 8.2985 15.3484 8.26465 15.86 8.30491C16.3781 8.40158 16.503 9.18596 16.0427 9.44284C15.7286 9.61208 15.3555 9.50588 15.015 9.53573H14.3181V8.28733ZM16.157 6.87432C16.2711 7.27714 15.8828 7.63882 15.4948 7.58335H14.3181C14.3263 7.20347 14.302 6.79115 14.33 6.43127C14.8014 6.44454 15.2772 6.40419 15.7459 6.45237C15.9472 6.50296 16.1158 6.66851 16.157 6.87432ZM18.989 0.90048C19.0108 1.66978 18.9921 2.47974 18.9984 3.26465C18.997 6.45579 19.0015 9.64685 18.9959 12.8382C18.9752 14.0341 17.9153 15.0733 16.7277 15.0972C15.5388 15.102 14.3498 15.0979 13.1608 15.0993V10.2749C14.4563 10.2682 15.7524 10.2885 17.0474 10.2648C17.6481 10.2271 18.3061 9.83073 18.334 9.16965C18.4048 8.50571 17.7788 8.04649 17.1845 7.97396C16.9561 7.96802 16.9627 7.90736 17.1845 7.8809C17.7513 7.75839 18.1964 7.17173 18.0297 6.58419C17.8876 5.96624 17.2045 5.72707 16.6364 5.72825C15.4781 5.72038 14.3195 5.72715 13.1611 5.72487C13.1686 4.82422 13.1455 3.92261 13.1735 3.02262C13.2653 1.84825 14.3519 0.879776 15.5229 0.900787C16.6784 0.900611 17.8337 0.900612 18.989 0.900568V0.90048Z"
          fill="url(#paint0_linear_18062_257)"
        />
        <path
          d="M0.0706067 3.14441C0.10019 1.95034 1.16462 0.919671 2.35077 0.90222C3.53521 0.898571 4.71982 0.901693 5.90426 0.900638C5.90101 4.89572 5.91068 8.89125 5.89938 12.8861C5.85375 14.0657 4.80093 15.0767 3.6277 15.0976C2.44102 15.1019 1.25421 15.0982 0.0674857 15.0994V10.1124C1.22019 10.3847 2.42897 10.5006 3.60493 10.32C4.30785 10.2069 5.07694 9.8617 5.31492 9.13244C5.49005 8.50864 5.39145 7.85213 5.41752 7.21189V5.72503H3.38241C3.37327 6.7084 3.40114 7.69349 3.36769 8.67568C3.31283 9.27939 2.71496 9.66297 2.14558 9.64248C1.43945 9.64996 0.0401437 9.13073 0.0401437 9.13073C0.0366271 7.28829 0.0606283 4.98091 0.0706067 3.14458V3.14441Z"
          fill="url(#paint1_linear_18062_257)"
        />
        <path
          d="M6.66332 6.32458C6.55619 6.34731 6.64178 5.95969 6.61439 5.81265C6.62169 4.88295 6.59914 3.95224 6.62683 3.02319C6.71835 1.84385 7.81328 0.872963 8.98901 0.900568H12.4514C12.4482 4.89565 12.4578 8.89118 12.4466 12.886C12.4009 14.0656 11.348 15.0766 10.1747 15.0975C8.988 15.102 7.80115 15.0982 6.61435 15.0994V9.63542C7.42487 10.3005 8.52649 10.404 9.53628 10.4058C10.2975 10.4055 11.0543 10.2881 11.7936 10.1126V9.11158C10.9605 9.5268 9.98112 9.79055 9.05758 9.55199C8.41334 9.39164 7.94568 8.76902 7.9561 8.10416C7.88146 7.41275 8.28675 6.68279 8.96619 6.47725C9.80978 6.21315 10.7292 6.41514 11.5199 6.75849C11.6893 6.84719 11.8613 6.95722 11.7936 6.67405V5.88725C10.4711 5.5726 9.06365 5.45682 7.73499 5.79911C7.35041 5.9076 6.97572 6.07213 6.66332 6.32467V6.32458Z"
          fill="url(#paint2_linear_18062_257)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_18062_257"
            x1="13.121"
            y1="7.69629"
            x2="18.9616"
            y2="7.69629"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#58B03A" />
            <stop offset="1" stopColor="#55B330" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_18062_257"
            x1="-0.0566993"
            y1="8.13598"
            x2="5.80856"
            y2="8.13598"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0F6EB6" />
            <stop offset="1" stopColor="#006DBA" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_18062_257"
            x1="6.60578"
            y1="7.83392"
            x2="12.4503"
            y2="7.83392"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DE0D3D" />
            <stop offset="1" stopColor="#E30138" />
          </linearGradient>
        </defs>
      </g>
    </svg>
  )
}

export default JCBIcon
